<template>
  <div v-if="body_show" class="bodys">
    <router-link v-if="data.test && data.test.testid" class="dio_link" :to="{
          path: '/course_dialogue',
          query: obj
        }">
      查看自我对话内容 <img src="@a/uxb.png" alt="" />
    </router-link>
    <div class="report_top" v-if="data.score!='' || data.assist_remark!=''">
      <img src="@a/report_h2.png" class="report_h2" />
      <div class="report_mb">
        <div ref="rew" class="report_m">
          <div class="report_tv clearfix">
            <div class="tv_l clearfix">
              <img :src="data.userdetail.headimgurl" />
              <div class="tv_lt">
                <h1>{{data.admission.name}}</h1>
                <h2>{{data.admission.career}}</h2>
                <h2>{{data.admission.job}}</h2>
              </div>
            </div>
            <img :src="data.score" class="tv_img" v-if="data.score!=''" />
          </div>
          <div class="report_bv">{{data.assist_remark}}</div>
        </div>
      </div>
    </div>
    <!-- 海报显示 -->
    <div class="report_main">
      <div v-for="(item,index) in data.report" :key="index">
        <img :src="item" :class="['report_img',index==0?'mt0':'']" @click="img_preview(index)" />
        <h5>*长按卡片可保存</h5>
      </div>
    </div>
    <div class="btn-group">
      <a class="nextTask1" @click="list_link(true)">我要做的更好</a>
      <!-- 判断是否是未解锁还是已通关 -->
      <!-- 未解锁 -->
      <div class="nextTask1 nextTask nextTask_lock" v-if="!classes_obj.bool">
        {{classes_obj.val}}
      </div>
      <!-- 已通关 -->
      <a class="nextTask1 nextTask" @click="toListView()" v-else-if="next.last">恭喜你 你通关了哟</a>
      <a v-else class="right-next">
        <a class="nextTask1 nextTask nextTask_lock" v-if="next.complete">开始挑战任务</a>
        <a  v-else>
          <div v-if="next.same" @click="list_link()">
            <!-- 1测评2音频3任务4小组讨论5案例 -->
            <div v-if="next.data.type == 1">开启“测评”</div>
            <div v-else-if="next.data.type == 2">开启下一课程</div>
            <div v-else-if="next.data.type == 3">开启“任务”</div>
            <div v-else-if="next.data.type == 5">开启“案例分析”</div>
          </div>
          <div class="nextTask1 nextTask" v-else @click="list_link()">挑战下一关</div>

          <!-- <a v-if="next.same" @click="list_link()">
            <a v-if="next.data.type == 1">开启“测评”</a>
            <a v-else-if="next.data.type == 2">开启下一课程</a>
            <a v-else-if="next.data.type == 3">开启“任务”</a>
            <a v-else-if="next.data.type == 5">开启“案例分析”</a>
          </a>
          <a @click="list_link()" class="nextTask1 nextTask" v-else>挑战下一关</a> -->
        </a>
      </a>
    </div>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id"></public-level>
    <!-- 引入返回列表页面 -->
    <capacity-fixed  :cid="$route.query.cid"></capacity-fixed>
  </div>
</template>
<script>
import CapacityFixed from "@c/course/capacity-fixed"
import PublicLevel from '@c/course/public-level'
import { getselfreport} from "@/api/course";
import { ImagePreview} from "vant";
import { shareCon} from "@/utils/wxconfig";
import wx from "weixin-js-sdk"
import Bus from "@/utils/bus"
import {dateFormat} from '@/utils/tools'
export default {
  data() {
      return {
        cid: "",
        data: {},
        body_show: false,
        report_mh: 0,
        next: {},
        obj: {},
        level_list_id:'',
        // 是否开课
        classes_obj:{
          bool:true,
          val:''
        },
        docTitle:''
      };
    },
    components:{
      CapacityFixed,
      PublicLevel
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 跳转列表页
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-23 15:59:19
      */
      toListView(){
        this.$router.push({
          path:'/list',
          query:{
            cid:this.$route.query.cid
          }
        });
      },
      // 跳转判断
      list_link(bool) {
        let item = this.next.data;
        // 返回上一任务页面
        if(bool){
          let q = this.$route.query;
          let path = this.data.test.skip;
          let u = path + '?cid=' + q.cid + '&pid=' + q.cpid + '&id=' + q.taskid +'&name='+ this.docTitle;
          // 判断id是否存在 
          if(item.id){
            u+='&level_list_id=' + item.id;
          }
          this.$router.push(u)
        }else{
          if (item.type == 1) {
            if(item.link.startsWith('http')){
              window.location.href = item.link+'?level_list_id=' + item.id;
            }else{
              this.$router.push({
                path:item.link,
                query:{
                  level_list_id:item.id
                }
              })
            }
          } else if (item.type == 2) {
            this.$router.push('/course_content?cid=' + item.cid + '&level_list_id=' + item.id+'&cpid=' + item.cpid + '&id=' + item.table_id)
          } else if (item.type == 3) {
            this.$router.push(item.link + '?cid=' + item.cid + '&level_list_id=' + item.id+'&pid=' + item.cpid + '&id=' + item.table_id)
          } else if (item.type == 5) {
            this.$router.push('/case_analysis?id=' + item.id +'&level_list_id=' + item.id+ '&cid=' + item.cid)
          }
        }
      },
      addTag() {},
      pullData() {
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        getselfreport({
          cid: this.$route.query.cid,
          cpid: this.$route.query.cpid,
          taskid: this.$route.query.taskid
        }).then(data => {
          // document.title = data.name + "报告";
          this.next = data.next;
          // 计算日期大小，判断是否有下一关或者未解锁
          this.dataSize();
          this.obj = {
            cid: this.$route.query.cid,
            testid: data.test.testid,
            taskid: this.$route.query.taskid
          }
          if (this.next instanceof Array && this.next.length == 0) {
            this.$toast("配置错误");
            return
          }
          this.body_show = true;
          this.data = data;
        });
      },
      /*
       *@param: 
       *@return: 
       *@Description: 比较日期时间大小
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-23 10:08:27
      */
      dataSize(){
        if(this.next && this.next.unlock_time){
          // 获取开课时间
          let d = dateFormat('yyyy-MM-dd hh:mm:ss',new Date(this.next.unlock_time*1000));
          let arr = d.split(' ');
          let date_ = arr[0].replace(/-/g, '');
          let time_ = arr[0].replace(/:/g, '');
          // 获取当前时间
          let date =new Date();
          let rq = String(date.getFullYear())+String(date.getMonth()+1)+String(date.getDate());
          let time = String(date.getHours())+String(date.getMinutes())+String(date.getSeconds());
          // 如果开课日期大于当前日期
          if(date_>rq || (date_==rq && time_>time)){
            this.classes_obj.bool=false;
            this.classes_obj.val='暂未解锁下一关卡';
            
          }
        }
        
      },
      img_preview(num) {
        let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          wx.previewImage({
            current: this.data.report[num], // 当前显示图片的http链接
            urls: this.data.report // 需要预览的图片http链接列表
          });
        } else {
          ImagePreview({
            images: this.data.report,
            startPosition: num,
            showIndex: false,
            onClose() {
              // do something
            }
          });
        }
      }
    },
    created() {
      Bus.$on('documentTitle',(data)=>{
        this.docTitle = data.level.name;
        document.title = data.level.name;
      });
      this.pullData();
      shareCon("course", this);
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  padding-bottom: 122px;
}

.pd_auto {
  padding: 30px;
}

.report_top {
  width: changeRem(13.8) + px;
  margin: 0 auto;
  margin-top: changeRem(1.6) + px;
  background: linear-gradient( 0deg, rgba(235, 80, 50, 1) 0%, rgba(245, 127, 23, 1) 100%);
  border-radius: changeRem(0.12) + px;
  padding: changeRem(0.48) + px changeRem(0.6) + px;
  text-align: center;
  position: relative;
  padding-bottom: 30px;
  margin-bottom: changeRem(0.5) + px;
  img.report_h2 {
    width: changeRem(9.12) + px;
    margin-top: 0;
    top: changeRem(-0.74) + px;
    position: absolute;
    left: 50%;
    margin-left: changeRem(-4.56) + px;
  }
  .report_mb {
    background: #ebebeb;
    width: changeRem(12.32) + px;
    height: auto;
    z-index: 1;
    margin-top: 64px;
    .report_m {
      margin: 0 auto;
      margin-top: changeRem(0.8) + px;
      margin-left: changeRem(0.4) + px;
      width: changeRem(12.32) + px;
      padding: changeRem(0.56) + px;
      padding-right: changeRem(0.68) + px;
      height: auto;
      background: rgba(255, 255, 255, 1);
      z-index: 2;
      position: relative;
      transform: translateX(changeRem(0.1) + px) translateY(changeRem(-0.4) + px);
      .report_tv {
        border-bottom: 2px dashed #ccc;
        padding-bottom: changeRem(0.48) + px;
        .tv_l {
          float: left;
          width: changeRem(9) + px;
          overflow: hidden;
          img {
            width: changeRem(2) + px;
            height: changeRem(2) + px;
            border-radius: 50%;
            float: left;
          }
          .tv_lt {
            margin-left: changeRem(0.44) + px;
            float: left;
            text-align: left;
            width: changeRem(6.5) + px;
            h1 {
              color: #333;
              font-size: changeRem(0.64) + px;
              line-height: changeRem(0.8) + px;
            }
            h2 {
              color: #333;
              font-size: changeRem(0.52) + px;
              line-height: changeRem(0.65) + px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
            }
          }
        }
      }
      .report_bv {
        margin-top: changeRem(0.48) + px;
        color: #333;
        font-size: changeRem(0.52) + px;
        line-height: changeRem(0.8) + px;
        text-align: justify;
      }
    }
  }
}

.report_main {
  background: #fff;
  text-align: left;
  img.report_img {
    width: 100%;
    height: auto;
    vertical-align: middle;
    margin-top: changeRem(0.6) + px;
  }
  img.report_img.mt0 {
    margin-top: 0px;
  }
  h5 {
    color: #333;
    font-size: changeRem(0.48) + px;
    padding-right: changeRem(0.6) + px;
    margin-top: changeRem(0.2) + px;
    margin-bottom: changeRem(0.2) + px;
    text-align: right;
    width: 100%;
  }
}

.tv_img {
  float: right;
  width: 100px;
}

.btn-group {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  line-height: 98px;
  width: 100%;
  max-width: 750px;
  position: fixed;
  z-index: 666;
  transform: translateX(-50%);
  left: 50%;
  bottom: 0;
  background-color: #EB5032;
  .nextTask1 {
    font-size: 34px;
    text-align: center;
    flex: 1;
    color: #ffffff;
    border-right: 1px solid #fff;
  }
  .nextTask {
    color: #ffffff;
    margin-left: auto;
    border-right: 0;
  }
  .nextTask_lock {
    background-color: #ccc;
    border-right: 0;
  }
  .right-next{
    font-size: 34px;
    text-align: center;
    flex: 1;
    color: #ffffff;
    margin-left: auto;
    border-left: 1px solid #fff;
    border-right: 0;
  }
}

.dio_link {
  margin: 20px 30px;
  border-radius: 8px;
  box-sizing: border-box;
  height: 112px;
  background: linear-gradient(-90deg, rgba(245, 127, 23, 1), rgba(235, 80, 50, 1));
  line-height: 112px;
  padding: 0 34px;
  position: relative;
  display: block;
  font-size: 34px;
  color: #fff;
  img {
    position: absolute;
    width: 14px;
    top: 44px;
    right: 30px;
    display: inline-block;
  }
}
</style>
